import { Caption, MyRecording } from '@shared/models';

const CaptionSample: Caption = {
    id: 'c3fd5269-a721-4549-800c-8572e3026ea5',
    videoId: '63f4395b-bbd6-4c56-ab08-875fe6f0897a',
    url: 'arn:aws:states:ap-southeast-1:625136029318:execution:MyStateMachine-p4q7pf7le:6d436b50-b5cf-4a89-99e0-3cdcce80ace1',
    lang: null,
    translations: [
        {
            id: '17ef4715-6e17-4593-b5f9-6f52522214be',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831.vtt',
            language: 'eng',
        },
        {
            id: '342d8257-44cd-44e9-b36c-d64e6f8a8d6b',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831_es.vtt',
            language: 'es',
        },
        {
            id: '3faf6291-a456-4d60-8713-08258bcaf603',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831_ja.vtt',
            language: 'ja',
        },
        {
            id: '2c03c5b6-4463-4272-9073-df5eacb49e2a',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831_pt.vtt',
            language: 'pt',
        },
        {
            id: '677e5843-611b-4cd9-b748-1209647b12c7',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831_zh.vtt',
            language: 'zh',
        },
        {
            id: '19f960b8-fc0f-43a3-ac1f-fe420090c681',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831_de.vtt',
            language: 'de',
        },
        {
            id: 'eff2677d-55df-4e28-bf44-223eb28ea8fd',
            url: 'https://ascend-api-dev-files.s3.ap-southeast-1.amazonaws.com/subtitles/job-1727099643831_ar.vtt',
            language: 'ar',
        },
    ],
};

export const RECORDINGS_SKELETON_DATA: MyRecording[] = [
    {
        id: '_1',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_2',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_3',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_4',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_5',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_6',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_7',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
    {
        id: '_8',
        title: '',
        description: '',
        type: 'webinar',
        priceInCoins: 0,
        purchased: false,
        thumbnail: '',
        videoUrl: '',
        captions: CaptionSample,
    },
];
